module.exports = __webpack_public_path__ + "img/itqan.c4d7b195.png";